import FieldDropdown from "../../../../fields3/generic/dropdown/dropdown"
import FieldConfig from "../../../proto/field-config"
import {CompanyRole, CompanyRoleLabel} from "../../../../gd/const/company-role"
import FieldUserCompanyRole_GlistGroupModern from "./components/glist-group/modern"
import FieldDropdown_PopoverMenuMore from "../../../generic/dropdown/components/popover/popover-menu-more";

const companyRolesOptions: Option[] = [
    { value: CompanyRole.MANAGER,   label: CompanyRoleLabel[CompanyRole.MANAGER] },
    { value: CompanyRole.USER,      label: CompanyRoleLabel[CompanyRole.USER] },
    { value: CompanyRole.GUEST,     label: CompanyRoleLabel[CompanyRole.GUEST] },
    { value: CompanyRole.CLIENT,    label: CompanyRoleLabel[CompanyRole.CLIENT], excludeFromSelectable: true },
]

export default class FieldCompanyUserRole extends FieldDropdown {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel = "User company role"

        this.options            = _.get(config,'options',companyRolesOptions)

        // if true will add no value option to options list (by default true for custom fields)
        this.noValueOption      = _.get(config,'addNoValueOption',false)

        // Label for no value option
        this.noValueOptionLabel = _.get(config,'noValueOptionLabel','Not specified')

        // default placeholder for FORM element
        this.placeholder        = _.get(config,'placeholder','Please select')

        this.showMenuMore       = false

        this.components = _.assign({}, this.components, {
            glistGroupModern        : FieldUserCompanyRole_GlistGroupModern,
            PopoverMenuMore         : this.showMenuMore ? FieldDropdown_PopoverMenuMore : null,   // menu bottom more area
        })
    }

    groupValue(value:any) {
        return _.get(this._getOption(value),'value', null);
    }

    groupSortValue(value:any) {
        const numberValue = parseInt(value)
        return _.findIndex(companyRolesOptions, option=>option.value === numberValue)
    }
}
